/** Internal helper imports here ... DO NOT IMPORT SHIT YOU DO NOT NEED */
import Glide from '@glidejs/glide';

/**
 * Module description...
 *
 * @returns {{init: init}}
 */
export default (() => {
  /**
   * Other functions...
   */
  const init = () => {
    const mobnav = new Glide(".mob-nav", {
      type: 'carousel',
      rewind: true,
      bound: true,
      slidesToScroll: 1,
      perTouch: 2,
      perView: 6,
      breakpoints: {
        800: {
          perView: 5,
        },
        750: {
          perView: 4,
        },
        600: {
          perView: 4,
        },
        550: {
          perView: 2.5,
        },
        400: {
          perView: 2.5,
        },
        390: {
          perView: 2.5,
        },
      }
    });
    mobnav.mount();

    new Glide('.homeSlider', {
      type: 'carousel',
      slidesToScroll: 1,
      perTouch: 1,
      perView: 1,
      focusAt: 0,
      autoplay: 7000,
      hoverpause: false,
    }).mount();
    new Glide('#featuredProducts', {
      type: 'carousel',
      slidesToScroll: 10,
      perTouch: 1,
      perView: 1,
      focusAt: 0,
      breakpoints: {
        800: {
          perView: 2,
          peek: 150,
        },
        750: {
          perView: 2,
          peek: 100,
        },
        600: {
          perView: 1,
          peek: 150,
        },
        550: {
          perView: 1,
          peek: {
            before: 0,
            after: 100,
          }
        },
        400: {
          perView: 1,
          peek: {
            before: 0,
            after: 100,
          }
        },
        390: {
          perView: 1,
          peek: {
            before: 0,
            after: 100,
          }
        },
        300: {
          perView: 1,
          peek: {
            before: 0,
            after: 100,
          }
        }
      }
    }).mount();
    new Glide('#productMobile', {
      type: 'carousel',
      rewind: true,
      bound: true,
      slidesToScroll: 1,
      perTouch: 1,
      perView: 1,
      breakpoints: {
        800: {
          perView: 2,
          peek: 150,
        },
        750: {
          perView: 2,
          peek: 100,
        },
        600: {
          perView: 1,
          peek: 150,
        },
        550: {
          perView: 1,
          peek: 120,
        },
        400: {
          perView: 1,
          peek: 80,
        },
        390: {
          perView: 1,
          peek: 70,
        },
        300: {
          perView: 1,
          peek: 50,
        }
      }
    }).mount();
    new Glide('#featuredArticles', {
      type: 'carousel',
      slidesToScroll: 10,
      perTouch: 1,
      perView: 1,
      focusAt: 0,
      breakpoints: {
        800: {
          perView: 2,
          peek: 150,
        },
        750: {
          perView: 2,
          peek: 100,
        },
        600: {
          perView: 1,
          peek: 150,
        },
        550: {
          perView: 1,
          peek: {
            before: 0,
            after: 100,
          }
        },
        400: {
          perView: 1,
          peek: {
            before: 0,
            after: 100,
          }
        },
        390: {
          perView: 1,
          peek: {
            before: 0,
            after: 100,
          }
        },
        300: {
          perView: 1,
          peek: {
            before: 0,
            after: 100,
          }
        }
      }
    }).mount();
  };
  return {
    init,
  };
})();
